import type { LucideIcon } from 'lucide-react';
import { AlertTriangle, Info, Lightbulb, Sparkles } from 'lucide-react';

export type CalloutColorId =
  | 'info'
  | 'warning'
  | 'tip'
  | 'purple'
  | 'rose'
  | 'cyan'
  | 'slate';

/** Alinhado a RichTextEditorTone sem import circular. */
export type CalloutEditorTone = 'painel' | 'info' | 'tip' | 'warning';

export type CalloutColorStyle = {
  id: CalloutColorId;
  label: string;
  bg: string;
  border: string;
  icon: string;
  text: string;
  iconComp: LucideIcon;
  editorTone: CalloutEditorTone;
  swatch: string;
};

export const CALLOUT_COLORS: Record<CalloutColorId, CalloutColorStyle> = {
  info: {
    id: 'info',
    label: 'Azul',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    icon: 'text-blue-500',
    text: 'text-blue-800',
    iconComp: Info,
    editorTone: 'info',
    swatch: '#3b82f6',
  },
  warning: {
    id: 'warning',
    label: 'Âmbar',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    icon: 'text-amber-500',
    text: 'text-amber-800',
    iconComp: AlertTriangle,
    editorTone: 'warning',
    swatch: '#f59e0b',
  },
  tip: {
    id: 'tip',
    label: 'Verde',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    icon: 'text-emerald-500',
    text: 'text-emerald-800',
    iconComp: Lightbulb,
    editorTone: 'tip',
    swatch: '#10b981',
  },
  purple: {
    id: 'purple',
    label: 'Roxo',
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    icon: 'text-purple-500',
    text: 'text-purple-800',
    iconComp: Sparkles,
    editorTone: 'info',
    swatch: '#a855f7',
  },
  rose: {
    id: 'rose',
    label: 'Rosa',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    icon: 'text-rose-500',
    text: 'text-rose-800',
    iconComp: Info,
    editorTone: 'warning',
    swatch: '#f43f5e',
  },
  cyan: {
    id: 'cyan',
    label: 'Ciano',
    bg: 'bg-cyan-50',
    border: 'border-cyan-200',
    icon: 'text-cyan-500',
    text: 'text-cyan-800',
    iconComp: Info,
    editorTone: 'info',
    swatch: '#06b6d4',
  },
  slate: {
    id: 'slate',
    label: 'Cinza',
    bg: 'bg-slate-50',
    border: 'border-slate-200',
    icon: 'text-slate-500',
    text: 'text-slate-800',
    iconComp: Info,
    editorTone: 'painel',
    swatch: '#64748b',
  },
};

export const CALLOUT_COLOR_IDS = Object.keys(CALLOUT_COLORS) as CalloutColorId[];

export function isCalloutColorId(value: string | undefined | null): value is CalloutColorId {
  return Boolean(value && value in CALLOUT_COLORS);
}

export function getCalloutColor(
  id: string | undefined | null,
  fallback: CalloutColorId = 'info'
): CalloutColorStyle {
  if (isCalloutColorId(id)) return CALLOUT_COLORS[id];
  return CALLOUT_COLORS[fallback];
}
